import { createSelector } from '@ngrx/store';
import { ingredientsState } from '../root';

export const getIngredientsForProduct = (productId: number, locationNo: number) =>
    createSelector(
        ingredientsState,
        (ingredients) => ingredients.find((ingredient) => ingredient.ProductId === productId && ingredient.LocationNo === locationNo) || null
    );
